export default __webpack_public_path__ + "static/media/banner2.f1c8a532.jpeg";